import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { HelpService } from 'src/app/_service/help.service';
@Component({
  selector: 'app-manage-help',
  templateUrl: './manage-help.component.html',
  styleUrls: ['./manage-help.component.css']
})
export class ManageHelpComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; helpList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; title_filter = '';
  constructor(private sharedapi: SharedService, private helpapi: HelpService) { }

  ngOnInit(): void {

  }
  ngAfterViewInit() {
    this.loadHelpList(0, this.perpage);
  }

  async loadHelpList(pageIndex, perpage) {
    this.helpList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.title_filter;
    this.loading = true; this.loaded = false;
    await this.helpapi.getHelpList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.helpList = data.data;
      } else {
        this.helpList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadHelpList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadHelpList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.title_filter = '';
    this.loadHelpList(0, 25);
  }


}
